import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import Report from './Report';
import ChangePassword from './ChangePassword';
import Settings from './Settings';
import UserManagement from './UserManagement';
import ManageOrganizations from './ManageOrganizations';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard">
      <Header />
      <div className="dashboard-content">
        <Sidebar />
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/migration" element={<MainContent />} />
          <Route path="/report/:migrationId" element={<Report />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/manage-organizations" element={<ManageOrganizations />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
